import { observable, computed } from 'mobx';

import { AnalyticsStore, SerializedData, Store } from 'bernie-core';

import { trackAnalytics } from 'utility';
import { FlightsListing, ProgressBarDetails } from 'types/search/listings';
import { AnalyticsType } from 'types/shared';
import { FlightsShoppingPwaFlightSearchResultsFlightsSearch, FlightsStandardOffer } from '__generated__/api';
import ListingsAction = FlightsShoppingPwaFlightSearchResultsFlightsSearch.ListingsAction;

export class ListingsStore extends Store {
  @observable public loading: boolean;
  @observable public listings: FlightsListing[];
  @observable public listingsSkeletonCount: number;
  @observable public message: string;
  @observable public originDestination: string;
  @observable public shouldShowSkeletons: boolean;
  @observable public progressBarDetails: ProgressBarDetails;
  @observable public accessibilityMessage: string;
  @observable public appliedSortingAccessibility: string;
  @observable public appliedFilterAccessibility: string;
  @observable public selectedOfferIndex = -1;
  @observable
  public flightsListingsAnalytics: FlightsShoppingPwaFlightSearchResultsFlightsSearch.FlightsListingsAnalytics;
  @observable public pinnedListingUnavailableMessage: string;
  @observable public listingsAction?: ListingsAction;
  @observable public showMoreLoading: boolean;

  private maxViewOfferAnalytics?: AnalyticsType = null;

  @computed get offersFound(): boolean {
    return !this.loading && this.listings.length > 0;
  }

  public hydrate(data: SerializedData): void {
    this.selectedOfferIndex = -1;
    Object.assign(this, data);
  }

  public setMaxViewOfferAnalytics(value: AnalyticsType) {
    this.maxViewOfferAnalytics = value;
  }

  public trackOnViewedAnalytics = (analytics: AnalyticsStore) => {
    this.maxViewOfferAnalytics && trackAnalytics(this.maxViewOfferAnalytics, analytics);
  };

  public updateStoreListings(showMoreListingsStore: ListingsStore) {
    if (showMoreListingsStore) {
      if (showMoreListingsStore.listings !== null) {
        this.listings = this.listings.concat(showMoreListingsStore.listings);
      }
      this.listingsAction = showMoreListingsStore.listingsAction;
    }
  }

  public getSelectedOfferHygieneAmenitiesPresentation(
    offerIndex: number
  ): FlightsStandardOffer.HygieneAmenitiesPresentation {
    const offer = this.listings[offerIndex];

    return offer?.__typename === 'FlightsStandardOffer' && offer.journeys[0]?.hygieneAmenitiesPresentation;
  }
}

ListingsStore.DEFAULTS = {
  loading: true,
  listings: [],
  shouldShowSkeletons: false,
  selectedOfferIndex: -1,
  pinnedListingUnavailableMessage: '',
  showMoreLoading: false
};
